import styled from "styled-components";

export const StyledNotFound = styled.div`
    min-height: 100dvh;
    max-height: 100dvh;
    max-width: 100dvw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    && {
        color: ${(props) => props.theme.primaryTypographyColor};
        background-color: ${(props) => props.theme.primaryBackground};
    }
`;

export const StyledNotFoundBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledNotFoundImage = styled.img`
    height: 175px;
    width: 323px;
`;

export const StyledNotFoundInfoBlock = styled.div`
    margin-top: 40px;
    display: flex;
    gap: 16px;
    align-items: center;
`;
